/**
 * LandingSchool — /school route.
 * Faithful port of school.html from the AI-IDE design.
 *
 * No "Try Now" — schools onboard via invite/contact, so CTA is "Contact Us"
 * which scrolls to the form.
 */
import LandingShell from '@/components/landing/LandingShell';
import ContactSection from '@/components/landing/ContactSection';
import { LANDING_CTA, PAGE_SOURCE } from '@/lib/landingCTAs';

const SCHOOL_FEATURES = [
  {
    img: '/landing-v2/assets/teacher_assessment.webp',
    title: "Teacher's Assessment Suite",
    body: '10-minute post-class quiz. Instant results. Know exactly who needs help — before the next lesson begins.',
  },
  {
    img: '/landing-v2/assets/principal_heatmap.webp',
    title: "Principal's Diagnostic Heatmap",
    body: 'See every gap, every student, every topic — in one colour-coded view. Act before results do the talking.',
  },
  {
    img: '/landing-v2/assets/classroom_students.webp',
    title: 'Remediation Boosters',
    body: 'One click from the heatmap. A personalised revision session lands straight in the student\'s portal.',
  },
];

export default function LandingSchool() {
  return (
    <LandingShell activeNav="school">
      {/* ============== HERO ============== */}
      <section id="hero" style={{ padding: '130px 0 24px 0' }}>
        <div className="container text-center">
          <div className="nep-badge" style={{ margin: '0 auto 16px auto' }}>
            <span className="pulse-dot" /> FOR PRINCIPALS &amp; TEACHERS
          </div>
          <h1 style={{ fontSize: '3rem', marginBottom: 12 }}>
            Beyond Marks.<br />
            <span className="gradient-text">What Did They Actually Learn?</span>
          </h1>
          <p className="hero-subtitle" style={{ margin: '0 auto', maxWidth: 520, fontSize: '1.05rem' }}>
            Real-time competency maps for school leaders and classroom
            teachers — not just end-of-term results.
          </p>
          <div style={{ marginTop: 24, display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
            <a
              href={LANDING_CTA.CONTACT_ANCHOR}
              className="btn btn-primary btn-lg glow-btn"
              data-testid="school-contact-cta"
            >
              Contact Us
            </a>
          </div>
        </div>
      </section>

      {/* ============== THREE PILLARS ============== */}
      <section className="section-padding light-bg" style={{ padding: '48px 0' }}>
        <div className="container">
          <div className="section-header text-center" style={{ marginBottom: 32 }}>
            <span className="section-tag">WHAT SCHOOLS GET</span>
            <h2>Diagnostics That Drive Action.</h2>
          </div>
          <div className="philosophy-grid">
            {SCHOOL_FEATURES.map((f) => (
              <div className="philosophy-card text-center" key={f.title}>
                <img
                  src={f.img}
                  alt={f.title}
                  style={{ width: '100%', height: 220, objectFit: 'cover', borderRadius: 12, marginBottom: 20 }}
                />
                <h3>{f.title}</h3>
                <p>{f.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <ContactSection sourcePage={PAGE_SOURCE.SCHOOL} />
    </LandingShell>
  );
}
